import { useEffect, useState, useCallback, useMemo } from "react";
import { api } from "@/lib/api";

// Simple in-memory + localStorage cache for site content.
// Public site uses `useContent()` to render dynamic CMS data.
let cache = null;
let inflight = null;
const KEY = "fastag_content_cache_v1";

const listeners = new Set();

function notify() { listeners.forEach((fn) => fn(cache)); }

async function fetchContent(force = false) {
  if (cache && !force) return cache;
  if (inflight) return inflight;
  inflight = (async () => {
    try {
      const { data } = await api.get("/cms/public");
      cache = data;
      try { localStorage.setItem(KEY, JSON.stringify({ data, t: Date.now() })); } catch {}
      notify();
      return data;
    } finally {
      inflight = null;
    }
  })();
  return inflight;
}

export function primeContent() {
  // Load from cache first, then re-fetch in background
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed?.data) cache = parsed.data;
    }
  } catch {}
  fetchContent(true);
}

export function refreshContent() { return fetchContent(true); }

export function useContent() {
  const [data, setData] = useState(cache);
  useEffect(() => {
    const cb = (d) => setData(d);
    listeners.add(cb);
    if (!cache) fetchContent();
    return () => listeners.delete(cb);
  }, []);
  return data;
}
